/* TWT Pro Shop 2.0.0 — Echo Studios GbR. Ohne Frameworks. */
(function () {
  'use strict';

  var T = window.TWT || { routes: { root: '/', cart: '/cart', cartAdd: '/cart/add', cartChange: '/cart/change' }, cartType: 'page', strings: {} };
  var S = T.strings || {};
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var mqMobile = window.matchMedia('(max-width: 989px)');

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function announce(msg) {
    var live = $('[data-live]');
    if (!live) return;
    live.textContent = '';
    window.setTimeout(function () { live.textContent = msg; }, 60);
  }
  function money(cents) {
    return (cents / 100).toLocaleString('de-DE', { style: 'currency', currency: 'EUR' });
  }

  /* ---------- Header beim Scrollen ---------- */
  var header = $('[data-header]');
  if (header) {
    var ticking = false;
    var onScroll = function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        header.classList.toggle('is-scrolled', window.scrollY > 24);
        ticking = false;
      });
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- Drawer (Menü, Warenkorb, Filter mobil) ---------- */
  var backdrop = $('[data-backdrop]');
  var openDrawerEl = null;
  var lastTrigger = null;
  var FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]):not([type="hidden"]),select:not([disabled]),textarea:not([disabled]),summary,[tabindex]:not([tabindex="-1"])';

  function setTriggers(id, expanded) {
    $$('[aria-controls="' + id + '"][data-drawer-open]').forEach(function (b) { b.setAttribute('aria-expanded', expanded ? 'true' : 'false'); });
  }
  function openDrawer(el, trigger) {
    if (!el) return;
    if (openDrawerEl && openDrawerEl !== el) closeDrawer(false);
    if (el.hasAttribute('data-drawer-responsive')) {
      if (!mqMobile.matches) return;
      el.setAttribute('role', 'dialog');
      el.setAttribute('aria-modal', 'true');
    }
    lastTrigger = trigger || document.activeElement;
    openDrawerEl = el;
    el.classList.add('is-open');
    if (backdrop) backdrop.classList.add('is-open');
    document.body.classList.add('is-locked');
    setTriggers(el.id, true);
    window.setTimeout(function () {
      var first = $('[data-drawer-close]', el) || el;
      first.focus();
    }, reduceMotion ? 0 : 60);
  }
  function closeDrawer(restore) {
    var el = openDrawerEl;
    if (!el) return;
    el.classList.remove('is-open');
    if (el.hasAttribute('data-drawer-responsive')) { el.removeAttribute('role'); el.removeAttribute('aria-modal'); }
    if (backdrop) backdrop.classList.remove('is-open');
    document.body.classList.remove('is-locked');
    setTriggers(el.id, false);
    openDrawerEl = null;
    if (restore !== false && lastTrigger && document.contains(lastTrigger)) lastTrigger.focus();
  }
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-drawer-open]');
    if (opener) {
      e.preventDefault();
      openDrawer(document.getElementById(opener.getAttribute('data-drawer-open')), opener);
      return;
    }
    if (e.target.closest('[data-drawer-close]')) { e.preventDefault(); closeDrawer(); return; }
    if (e.target === backdrop) closeDrawer();
  });
  document.addEventListener('keydown', function (e) {
    if (!openDrawerEl) return;
    if (e.key === 'Escape') { closeDrawer(); return; }
    if (e.key !== 'Tab') return;
    var items = $$(FOCUSABLE, openDrawerEl).filter(function (n) { return n.offsetParent !== null || n === document.activeElement; });
    if (!items.length) { e.preventDefault(); return; }
    var first = items[0], last = items[items.length - 1];
    if (e.shiftKey && (document.activeElement === first || document.activeElement === openDrawerEl)) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });
  mqMobile.addEventListener && mqMobile.addEventListener('change', function () {
    if (openDrawerEl && openDrawerEl.hasAttribute('data-drawer-responsive') && !mqMobile.matches) closeDrawer(false);
  });

  /* ---------- Dropdowns im Header: Escape schließt ---------- */
  $$('[data-nav-item]').forEach(function (item) {
    item.addEventListener('focusin', function () { item.classList.add('is-open'); });
    item.addEventListener('focusout', function (e) { if (!item.contains(e.relatedTarget)) item.classList.remove('is-open'); });
    item.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && item.classList.contains('is-open')) {
        item.classList.remove('is-open');
        var link = item.querySelector('.nav__link');
        if (link) link.focus();
        item.classList.remove('is-open');
      }
    });
    item.addEventListener('mouseleave', function () { if (!item.contains(document.activeElement)) item.classList.remove('is-open'); });
  });

  /* ---------- Suche ---------- */
  var searchToggle = $('[data-search-toggle]');
  var searchBox = $('#HeaderSearch');
  if (searchToggle && searchBox) {
    searchToggle.setAttribute('role', 'button');
    searchToggle.setAttribute('aria-expanded', 'false');
    searchToggle.addEventListener('click', function (e) {
      e.preventDefault();
      var open = searchBox.hidden;
      searchBox.hidden = !open;
      searchToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) $('input[type="search"]', searchBox).focus();
    });
    searchBox.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { searchBox.hidden = true; searchToggle.setAttribute('aria-expanded', 'false'); searchToggle.focus(); }
    });
  }

  /* ---------- Hero-Slider ---------- */
  $$('[data-hero]').forEach(function (hero) {
    var slides = $$('[data-slide]', hero);
    var dots = $$('[data-dot]', hero);
    if (slides.length < 2) return;
    var index = 0, timer = null;
    var delay = parseInt(hero.getAttribute('data-autoplay'), 10) || 0;
    var pauseBtn = $('[data-hero-pause]', hero);
    var paused = reduceMotion;
    function go(i) {
      index = (i + slides.length) % slides.length;
      slides.forEach(function (s, n) {
        var on = n === index;
        s.classList.toggle('is-active', on);
        s.toggleAttribute('inert', !on);
        s.setAttribute('aria-hidden', on ? 'false' : 'true');
      });
      dots.forEach(function (d, n) { if (n === index) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current'); });
    }
    function stop() { if (timer) { window.clearInterval(timer); timer = null; } }
    function start() { stop(); if (delay > 0 && !paused) timer = window.setInterval(function () { go(index + 1); }, delay * 1000); }
    dots.forEach(function (d) { d.addEventListener('click', function () { go(parseInt(d.getAttribute('data-dot'), 10)); start(); }); });
    if (pauseBtn) {
      if (paused) { pauseBtn.setAttribute('aria-label', pauseBtn.getAttribute('data-label-play')); }
      pauseBtn.addEventListener('click', function () {
        paused = !paused;
        pauseBtn.setAttribute('aria-label', pauseBtn.getAttribute(paused ? 'data-label-play' : 'data-label-pause'));
        pauseBtn.innerHTML = paused ? '<svg class="icon" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M7 4.5v15L19.5 12z"/></svg>' : '<svg class="icon" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M6 5h4v14H6zM14 5h4v14h-4z"/></svg>';
        if (paused) stop(); else start();
      });
    }
    hero.addEventListener('mouseenter', stop);
    hero.addEventListener('mouseleave', start);
    hero.addEventListener('focusin', stop);
    hero.addEventListener('focusout', function (e) { if (!hero.contains(e.relatedTarget)) start(); });
    /* Wischen */
    var x0 = null;
    hero.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    hero.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 50) { go(index + (dx < 0 ? 1 : -1)); start(); }
      x0 = null;
    });
    start();
  });

  /* ---------- Karussell (Pro Shop) ---------- */
  function initCarousel(root) {
    var track = $('[data-carousel-track]', root);
    var prev = $('[data-carousel-prev]', root);
    var next = $('[data-carousel-next]', root);
    var bar = $('[data-carousel-progress]', root);
    if (!track) return;
    function step() {
      var item = track.firstElementChild;
      if (!item) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      return item.getBoundingClientRect().width + gap;
    }
    function update() {
      var max = track.scrollWidth - track.clientWidth;
      var ratio = track.scrollWidth ? track.clientWidth / track.scrollWidth : 1;
      var pos = max > 0 ? track.scrollLeft / max : 0;
      if (bar) {
        bar.style.width = Math.max(ratio * 100, 8) + '%';
        bar.style.transform = 'translateX(' + (pos * (1 / Math.max(ratio, 0.08) - 1) * 100) + '%)';
      }
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max - 2;
      var media = $('.card__media', track);
      if (media) root.style.setProperty('--carousel-media-h', media.offsetHeight / 2 + 'px');
    }
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: reduceMotion ? 'auto' : 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: reduceMotion ? 'auto' : 'smooth' }); });
    track.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
    window.addEventListener('resize', update);
    update();
    window.addEventListener('load', update);
  }
  $$('[data-carousel]').forEach(initCarousel);

  /* ---------- Produktseite ---------- */
  function initProduct(root) {
    var jsonEl = $('[data-product-json]', root);
    var variants = jsonEl ? JSON.parse(jsonEl.textContent) : [];
    var form = $('form[data-type="add-to-cart-form"]', root) || $('form[action*="/cart/add"]', root);
    var idInput = form ? $('input[name="id"][data-variant-id]', form) : null;
    var groups = $$('fieldset[data-option-index]', root);
    var addBtn = $('[data-add-button]', root);
    var addLabel = $('[data-add-label]', root);
    var errorEl = $('[data-cart-error]', root);
    var priceEl = $('[data-price]', root);
    var compareEl = $('[data-compare]', root);
    var compareVal = $('[data-compare-value]', root);
    var saleBadge = $('[data-sale-badge]', root);
    var saleLabel = $('[data-sale-label]', root);

    /* Galerie */
    var gTrack = $('[data-gallery-track]', root);
    var thumbs = $$('[data-thumb]', root);
    var counter = $('[data-gallery-counter]', root);
    var slides = gTrack ? $$('[data-media-id]', gTrack) : [];
    function currentSlideIndex() {
      if (!gTrack || !gTrack.clientWidth) return 0;
      return Math.round(gTrack.scrollLeft / gTrack.clientWidth);
    }
    function markThumb(i) {
      thumbs.forEach(function (t, n) { if (n === i) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current'); });
      if (counter) counter.textContent = (i + 1) + ' / ' + slides.length;
    }
    function showSlide(i, smooth) {
      if (!gTrack || !slides[i]) return;
      gTrack.scrollTo({ left: slides[i].offsetLeft - gTrack.offsetLeft - gTrack.clientLeft, behavior: smooth && !reduceMotion ? 'smooth' : 'auto' });
      markThumb(i);
    }
    function showMedia(mediaId, smooth) {
      for (var i = 0; i < slides.length; i++) {
        if (String(slides[i].getAttribute('data-media-id')) === String(mediaId)) { showSlide(i, smooth); return; }
      }
    }
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { showSlide(i, true); }); });
    var gp = $('[data-gallery-prev]', root), gn = $('[data-gallery-next]', root);
    if (gp) gp.addEventListener('click', function () { showSlide(Math.max(0, currentSlideIndex() - 1), true); });
    if (gn) gn.addEventListener('click', function () { showSlide(Math.min(slides.length - 1, currentSlideIndex() + 1), true); });
    if (gTrack) {
      gTrack.addEventListener('scroll', function () { window.requestAnimationFrame(function () { markThumb(currentSlideIndex()); }); }, { passive: true });
      gTrack.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); showSlide(Math.min(slides.length - 1, currentSlideIndex() + 1), true); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); showSlide(Math.max(0, currentSlideIndex() - 1), true); }
      });
      var startThumb = thumbs.findIndex ? thumbs.findIndex(function (t) { return t.getAttribute('aria-current') === 'true'; }) : -1;
      if (startThumb > 0) showSlide(startThumb, false);
    }

    /* Varianten */
    function selectedValues() {
      return groups.map(function (g) { var c = $('input:checked', g); return c ? c.value : null; });
    }
    function findVariant(vals) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i], ok = true;
        for (var n = 0; n < vals.length; n++) { if (v.options[n] !== vals[n]) { ok = false; break; } }
        if (ok) return v;
      }
      return null;
    }
    function refreshAvailability(vals) {
      groups.forEach(function (g, gi) {
        $$('.pill', g).forEach(function (pill) {
          var input = $('input', pill);
          var test = vals.slice(); test[gi] = input.value;
          var v = findVariant(test);
          var unavailable = !(v && v.available);
          pill.classList.toggle('is-unavailable', unavailable);
          var label = $('label', pill);
          var hint = $('.visually-hidden', label);
          if (unavailable && !hint) { hint = document.createElement('span'); hint.className = 'visually-hidden'; hint.textContent = ' – ' + (S.soldOut || 'Ausverkauft'); label.appendChild(hint); }
          if (!unavailable && hint) hint.remove();
        });
      });
    }
    function setButton(state) {
      if (!addBtn) return;
      addBtn.disabled = state !== 'add';
      if (addLabel) addLabel.textContent = state === 'add' ? (S.addToCart || 'In den Warenkorb') : state === 'soldout' ? (S.soldOut || 'Ausverkauft') : (S.unavailable || 'Nicht verfügbar');
    }
    function onChange(fromUser) {
      var vals = selectedValues();
      groups.forEach(function (g) {
        var out = $('[data-option-output]', g), c = $('input:checked', g);
        if (out) out.textContent = c ? (c.getAttribute('data-label') || c.value) : '';
      });
      refreshAvailability(vals);
      var v = findVariant(vals);
      if (errorEl) errorEl.hidden = true;
      if (!v) { setButton('unavailable'); return; }
      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.textContent = money(v.price);
      var sale = v.compare_at_price && v.compare_at_price > v.price;
      if (compareEl) compareEl.hidden = !sale;
      if (compareVal && sale) compareVal.textContent = money(v.compare_at_price);
      if (saleBadge) saleBadge.hidden = !sale;
      if (saleLabel) saleLabel.hidden = !sale;
      setButton(v.available ? 'add' : 'soldout');
      if (fromUser) {
        if (v.featured_media) showMedia(v.featured_media.id, true);
        try {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        } catch (err) { /* ignorieren */ }
      }
    }
    groups.forEach(function (g) { g.addEventListener('change', function () { onChange(true); }); });
    if (groups.length) onChange(false);

    /* Menge */
    $$('[data-qty-step]', root).forEach(function (b) {
      b.addEventListener('click', function () {
        var input = $('input[name="quantity"]', root);
        var n = (parseInt(input.value, 10) || 1) + parseInt(b.getAttribute('data-qty-step'), 10);
        input.value = Math.min(99, Math.max(1, n));
      });
    });

    /* In den Warenkorb (AJAX bei Drawer) */
    if (form && T.cartType === 'drawer' && $('#CartDrawer')) {
      form.addEventListener('submit', function (e) {
        if (e.submitter && e.submitter.classList.contains('shopify-payment-button__button')) return;
        e.preventDefault();
        if (!addBtn || addBtn.disabled) return;
        addBtn.classList.add('is-loading');
        addBtn.setAttribute('aria-busy', 'true');
        var fd = new FormData(form);
        fd.append('sections', 'cart-drawer');
        fd.append('sections_url', window.location.pathname);
        fetch(T.routes.cartAdd + '.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' } })
          .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
          .then(function (res) {
            if (!res.ok || res.json.status) {
              if (errorEl) { errorEl.textContent = res.json.description || res.json.message || S.error; errorEl.hidden = false; }
              return;
            }
            if (res.json.sections) renderSections(res.json.sections);
            announce(S.added || 'Zum Warenkorb hinzugefügt');
            openDrawer($('#CartDrawer'), $('[data-cart-icon]'));
          })
          .catch(function () { if (errorEl) { errorEl.textContent = S.error; errorEl.hidden = false; } })
          .then(function () { addBtn.classList.remove('is-loading'); addBtn.removeAttribute('aria-busy'); });
      });
    }
  }
  $$('[data-product]').forEach(initProduct);

  /* ---------- Warenkorb: Section Rendering ---------- */
  function updateCount(count) {
    $$('.cart-bubble').forEach(function (b) { b.textContent = count > 0 ? count : ''; b.setAttribute('data-count', count); });
    var icon = $('[data-cart-icon]');
    if (icon) {
      var label = icon.getAttribute('aria-label') || '';
      icon.setAttribute('aria-label', label.replace(/\d+/, count));
    }
  }
  function renderSections(sections) {
    Object.keys(sections).forEach(function (id) {
      var html = sections[id];
      if (!html) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('[data-cart-section="' + (id === 'cart-drawer' ? 'cart-drawer' : id) + '"]');
      var old = document.querySelector('[data-cart-section="' + id + '"]');
      if (fresh && old) old.replaceWith(fresh);
      if (fresh && fresh.hasAttribute('data-cart-count')) updateCount(parseInt(fresh.getAttribute('data-cart-count'), 10) || 0);
    });
  }
  function cartSectionIds() {
    return $$('[data-cart-section]').map(function (n) { return n.getAttribute('data-cart-section'); });
  }
  var busy = false;
  function changeLine(line, qty, focusKey, container) {
    if (busy) return;
    busy = true;
    var ids = cartSectionIds();
    var inDrawer = container && container.closest('#CartDrawer');
    document.documentElement.style.cursor = 'progress';
    fetch(T.routes.cartChange + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty, sections: ids, sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
      .then(function (res) {
        if (!res.ok || res.json.status) { announce(res.json.description || S.error); return; }
        if (res.json.sections) renderSections(res.json.sections);
        if (typeof res.json.item_count === 'number') updateCount(res.json.item_count);
        announce(S.updated || 'Warenkorb aktualisiert');
        var scope = inDrawer ? $('#CartDrawer') : document;
        var target = focusKey ? $('[data-focus-key="' + focusKey + '"]', scope) : null;
        if (!target) target = inDrawer ? ($('[data-drawer-close]', scope)) : $('#MainContent h1');
        if (target) { if (!target.hasAttribute('tabindex') && target.tagName === 'H1') target.setAttribute('tabindex', '-1'); target.focus(); }
      })
      .catch(function () { announce(S.error); })
      .then(function () { busy = false; document.documentElement.style.cursor = ''; });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-line-change]');
    if (b) {
      e.preventDefault();
      var qty = Math.max(0, parseInt(b.getAttribute('data-qty-value'), 10) || 0);
      changeLine(parseInt(b.getAttribute('data-line-change'), 10), qty, qty > 0 ? b.getAttribute('data-focus-key') : null, b);
      return;
    }
    var opener = e.target.closest('[data-cart-open]');
    if (opener && $('#CartDrawer')) { e.preventDefault(); openDrawer($('#CartDrawer'), opener); }
  });
  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-line-input]');
    if (input) {
      var q = Math.max(0, parseInt(input.value, 10) || 0);
      changeLine(parseInt(input.getAttribute('data-line-input'), 10), q, input.getAttribute('data-focus-key'), input);
    }
    var note = e.target.closest('[data-cart-note]');
    if (note) {
      fetch(T.routes.cart + '/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: note.value }) });
    }
  });
  document.addEventListener('keydown', function (e) {
    var input = e.target.closest && e.target.closest('[data-line-input]');
    if (input && e.key === 'Enter') { e.preventDefault(); input.dispatchEvent(new Event('change', { bubbles: true })); }
  });

  /* ---------- Produktempfehlungen ---------- */
  $$('[data-recommendations]').forEach(function (el) {
    var url = el.getAttribute('data-url');
    if (!url || el.children.length) return;
    var load = function () {
      fetch(url).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-recommendations]');
        if (fresh && fresh.innerHTML.trim()) el.innerHTML = fresh.innerHTML; else el.remove();
      }).catch(function () {});
    };
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) { if (entries[0].isIntersecting) { io.disconnect(); load(); } }, { rootMargin: '400px 0px' });
      io.observe(el);
    } else { load(); }
  });

  /* ---------- Filter & Sortierung ---------- */
  var filterForm = $('[data-filter-form]');
  if (filterForm) {
    filterForm.addEventListener('change', function (e) {
      if (mqMobile.matches) return; /* mobil: Übernehmen-Button */
      if (e.target.type === 'number') return;
      filterForm.requestSubmit ? filterForm.requestSubmit() : filterForm.submit();
    });
  }
  var sortSelect = $('[data-sort-select]');
  if (sortSelect) sortSelect.addEventListener('change', function () { sortSelect.form.submit(); });

  /* ---------- Formular-Rückmeldungen ---------- */
  var focusTarget = $('[data-focus-on-load]');
  if (focusTarget) {
    focusTarget.scrollIntoView({ block: 'center', behavior: 'auto' });
    focusTarget.focus({ preventScroll: true });
  }
  $$('details[data-open-on-error]').forEach(function (d) { if ($('.form-msg--error', d)) d.open = true; });
})();
